import * as React from 'react';
import qs from 'querystring';
import Text from 'components/Text';
import openPopup from 'utils/openPopup';
import Image from 'components/Image';
import Button from 'components/ButtonDeprecated';
import Heading from 'components/Heading';
import * as messenger from '../lib/messenger';
import ShareSDKHeader from './ShareSDKHeader';
import ShareSDKLoginPopup from './ShareSDKLoginPopup';
import { LOGIN_POP_PATH, COMPOSER_PATH } from '../routes';
import { isWithinIframe } from './ShareSDKUtility';

import Box from 'components/Box';
import Row from 'components/Row';

import EventTracking from 'lib/EventTracking';

// $FlowFixMe
import './styles/ShareSDKLogin.scss';

messenger.removeIsTrusted();

class ShareSDKLogin extends React.Component<any, any> {
  componentDidMount() {
    this.listener = messenger.listen('SIGN_IN', (source) => {
      messenger.send('SIGN_IN_ACK', source);
      // this is to ensure that the possible query params get passed forward!
      window.location.replace(COMPOSER_PATH + window.location.search);
    });

    EventTracking.trackKey('share_sdk.login.share_sdk_login.connect_to_remind.view');
  }

  componentWillUnmount() {
    if (this.listener) {
      this.listener.unlisten();
    }
  }

  listener: any;

  render() {
    if (isWithinIframe()) {
      const open = () => {
        EventTracking.trackKey('share_sdk.login.share_sdk_login.connect_to_remind.click');

        openPopup(LOGIN_POP_PATH, 'Sign into Remind', {
          height: 715,
          width: 800,
        });
      };

      let query = window.location.search;
      // window.location.search returns string starting with '?'
      if (query && query.charAt(0) === '?') {
        query = query.substr(1);
      }
      const isLTI = qs.parse(query).lti;
      let LTIText = null;
      if (isLTI === 'canvas') {
        LTIText = (
          <Text
            className="ShareSDKLogin-container-content-description"
            lineHeight="xlarge"
            size="xxxsmall"
            element="div"
            color="graphite"
          >
            Connect your Remind account to share directly to Remind from your Canvas Account. Remind
            is a private mobile messaging platform that enables teachers, parents, students, and
            administrators to communicate with everyone at once. The platform has more than 20
            million monthly active users across the United States.
          </Text>
        );
      } else if (isLTI === 'schoology') {
        LTIText = (
          <Text
            className="ShareSDKLogin-container-content-description"
            lineHeight="xlarge"
            size="xxxsmall"
            element="div"
            color="graphite"
          >
            Connect your Remind account to share directly to Remind from your Schoology Account.
            Remind is a private mobile messaging platform that enables teachers, parents, students,
            and administrators to communicate with everyone at once. The platform has more than 20
            million monthly active users across the United States.
          </Text>
        );
      }

      return (
        <div className="ShareSDKLogin">
          <ShareSDKHeader />
          <Box size="xmedium" className="ShareSDKLogin-container">
            <Image
              className="ShareSDKLogin-container-logo"
              src={require('assets/square_logo.svg')}
            />
            <div className="ShareSDKLogin-container-hero">
              <Image
                className="ShareSDKLogin-container-hero-image"
                src={require('assets/images/remind_LTI_cover_image.png')}
              />
            </div>
            <div className="ShareSDKLogin-container-content">
              <Heading level="1" levelStyle="2">
                Share directly to your Remind classes!
              </Heading>
              <Row size="xxxlarge">{LTIText}</Row>
              <Row size="small">
                {
                  'In some browsers you may have to click "connect" twice because of blocked popups.'
                }
              </Row>
              <Row size="xxxlarge">
                <Button
                  onClick={() =>
                    // Pre-chromium edge (and probably others) don't have this api.
                    // $FlowFixMe
                    document.requestStorageAccess
                      ? document
                          .requestStorageAccess()
                          .then(() => {
                            // Now we have first-party storage access!
                            // Let's access some items from the first-party cookie jar
                            document.cookie = 'remind_third_party=true'; // drop a test cookie in order to start gaining access to cookies.
                          })
                          .catch((error) => {
                            // error obtaining storage access.
                            console.error(
                              'Could not get access for third-party cookie workaround: ' + error
                            );
                            window.location.replace('/share_sdk/noCookies');
                          })
                          .finally(() => {
                            open();
                          })
                      : open()
                  }
                  size="xsmall"
                >
                  Connect to Remind
                </Button>
              </Row>
            </div>
          </Box>
        </div>
      );
    } else {
      return <ShareSDKLoginPopup notIframe />;
    }
  }
}

export default ShareSDKLogin;
